<template>
  <div class="resultados">
    <MsgErroFormularios v-if="erro && msgErros" :mensagens="msgErros" />
    <table>
      <thead>
        <tr>
          <th>Título do Formulário</th>
          <th>Unidade Administrativa</th>
          <th>Data de Abertura</th>
          <th>Data de Encerramento</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="formulario in formularios" :key="formulario.id">
          <td data-label="Titulo:">
            <span>{{ formulario.titulo }}</span>
          </td>
         <td data-label="Unidade:">
            <span>{{ getUnidadeNome(formulario.id_unidade) }}</span>
          </td>
          <td data-label="Data Início:">
            <span>{{ formatarData(formulario.data_inicio) }}</span>
          </td>
          <td data-label="Data Final:">
            <span>{{ formatarData(formulario.data_final) }}</span>
          </td>
          <td class='coluna-acoes'>
            <div class="coluna-acoes-tabela">
              <div class="icone-tabela">
                <router-link :to="{ name: 'FormularioShow', params: { id: formulario.id } }">
                  <img src="../../assets/imagens/icon-view.svg" alt="Visualizar" title="Visualizar" />
                </router-link>
              </div>
              <div v-if="podeEscrever('formularios')" class="icone-tabela">
                <router-link :to="{ name: 'FormularioEdit', params: { id: formulario.id } }">
                  <img src="../../assets/imagens/icon-edit.svg" alt="Editar" title="Editar" />
                </router-link>
              </div>
              <span v-if="podeEscrever('formularios')" class="icone-tabela" type="button" @click="opcoesExcluir(formulario.id)">
                <img src="../../assets/imagens/icon-delete-preto.svg" alt="Excluir" title="Excluir" />
              </span>
              <div class="icone-tabela">
                <router-link :to="{ name: 'VisualizarRespostaFormulario', params: { id: formulario.id } }">
                  <img src="../../assets/imagens/visualizar-resposta-tabela-formulario2.png" alt="VisualizarRespostaFormulario" title="Visualizar Respostas" />
                </router-link>
              </div>
              <!-- NOVO BOTÃO PARA GERAR PDF -->
              <span v-if="formularioEncerrado(formulario.data_final)" class="icone-tabela" type="button" @click="gerarRelatorio(formulario)">
                <img
                  src="../../assets/imagens/icon-pdf.svg"
                  alt="Gerar Relatório PDF"
                  title="Gerar Relatório PDF"
                />
              </span>
              </div>
          </td>
          <div class="modal-exclusao" :id="formulario.id">
            <div class="modal-mask">
              <div class="modal-container">
                <div class="modal-header">
                  <h2>Deseja mesmo excluir este Formulário?</h2>
                </div>
                <div class="modal-body">
                  <p>Dados do Formulário:</p>
                  <div class="dados">
                    <div class="texto-centralizado">
                      Título: <span>{{ formulario.titulo }}</span>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button class="btn-confirmar-exclusao" @click="excluirLinha(formulario.id)">Sim</button>
                  <button class="btn-cancelar-exclusao" @click="opcoesExcluir(formulario.id)">Não</button>
                </div>
              </div>
            </div>
          </div>
        </tr>
        <tr v-if="!formularios || formularios.length === 0" class="sem-resultados">
            <td colspan="5"><p><b>Nenhum Resultado Encontrado</b></p></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import MsgErroFormularios from "../MsgErroFormularios";
  import FormularioApi from "../../services/FormularioApi";
  import { parseISO, format } from "date-fns"
  import UnidadesApi from "../../services/UnidadesApi";

  export default {
    name: "TabelaResultadosFormularios",
    props: {
      formularios: Array,
    },
    components: {
      MsgErroFormularios,
    },
    data() {
      return {
        msgErros: {
          formulario: '',
        },
        erro: false,
        unidades: [],
      };
    },
    created() {
      this.formularioApi = new FormularioApi();
      this.unidadeApi = new UnidadesApi();
      this.carregarUnidades();
    },
    methods: {
      async carregarUnidades() {
        try {
          this.unidades = await this.unidadeApi.getUnidades();
        } catch (err) {
          console.error("Não foi possível carregar a lista de unidades.", err);
        }
      },
      getUnidadeNome(id) {
        if (!this.unidades || this.unidades.length === 0) {
          return id;
        }
        
        const unidade = this.unidades.find(u => u.id === id);
        
        if (unidade) {
          // Retorna o nome e a sigla (se existir).
          return `${unidade.nome} ${unidade.sigla ? `(${unidade.sigla})` : ''}`;
        }
        
        return id;
      },
      formatarData: function (value) {
        if (!value) return'';
        try { return format(parseISO(value), "dd/MM/yyyy");
        } catch (error) {
          return "Data inválida";
        }
      },
      opcoesExcluir(formularioId) {
        let modalExclusao = document.getElementsByClassName('modal-exclusao');
        for (let i = 0; i < modalExclusao.length; i++) {
          if (modalExclusao[i].id == formularioId) {
            if (modalExclusao[i].style.visibility !== "visible") {
              modalExclusao[i].style.visibility = "visible";
            } else {
              modalExclusao[i].style.visibility = "hidden";
            }
          }
        }
      },

      async excluirLinha(formularioId) {
        this.opcoesExcluir(formularioId);
        try {
          this.erro = false;
          await this.formularioApi.destroyFormulario(formularioId);
          window.location.reload();
        } catch (err) {
          this.erro = true;          
          if (err.response && err.response.data && err.response.data.error) {
            this.msgErros.formulario = err.response.data.error;
          } else {
            this.msgErros.formulario = "Não foi possível excluir o formulário.";
          }
          
          console.error(err);
        }
      },
      formularioEncerrado(dataFinal) {
        if (!dataFinal) return false;

        try {
          const hoje = new Date();
          const dataFinalFormulario = parseISO(dataFinal);

          // Zera horas para evitar erro por horário
          hoje.setHours(0, 0, 0, 0);
          dataFinalFormulario.setHours(0, 0, 0, 0);

          return hoje > dataFinalFormulario;
        } catch (e) {
          return false;
        }
      },
      async gerarRelatorio(formulario) {
        if (!formulario || !formulario.id) return;

        // Mostra um toast de "carregando" que não some sozinho
        const toastId = this.$bvToast.toast('Gerando seu relatório em PDF. Aguarde...', {
          title: 'Aguarde',
          variant: 'info',
          solid: true,
          noAutoHide: true
        });

        try {
          const response = await this.formularioApi.gerarRelatorioPdf(formulario.id);

          // Tenta extrair o nome do arquivo do cabeçalho Content-Disposition (enviado pelo Rails).
          const contentDisposition = response.headers['content-disposition'];
          let filename;
          if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
            if (filenameMatch && filenameMatch.length > 1) {
              filename = filenameMatch[1];
            }
          }
          // Se não encontrar o nome no cabeçalho, usa o título do formulário como fallback.
          if (!filename) {
            filename = `relatorio_formulario_${formulario.titulo.replace(/[^a-z0-9_.-]+/gi, '_')}.pdf`;
          }

          // Cria um objeto de arquivo (blob) a partir da resposta da API
          const blob = new Blob([response.data], { type: 'application/pdf' });

          // Cria um link temporário na memória para iniciar o download
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = filename;
          document.body.appendChild(link);
          link.click();

          // Limpa o link da memória
          document.body.removeChild(link);
          window.URL.revokeObjectURL(link.href);

          // Esconde o toast de "Aguarde"
          this.$bvToast.hide(toastId);

        } catch (error) {
          this.$bvToast.hide(toastId); // Garante que o toast de "Aguarde" seja escondido em caso de erro
          console.error("Erro ao gerar relatório PDF:", error);
          let errorMessage = 'Não foi possível gerar o PDF. Verifique se este formulário já possui uma avaliação associada.';
          if (error.response && error.response.data && error.response.data.toString() === '[object Blob]') {
            // Tenta ler a mensagem de erro do backend se for um blob
            const reader = new FileReader();
            reader.onload = (e) => {
              try {
                const errorJson = JSON.parse(e.target.result);
                errorMessage = errorJson.error || errorMessage;
              } finally {
                this.$bvToast.toast(errorMessage, { title: 'Erro', variant: 'danger', solid: true });
              }
            };
            reader.readAsText(error.response.data);
          } else {
            this.$bvToast.toast(errorMessage, { title: 'Erro', variant: 'danger', solid: true });
          }
        }
      },
    },
  };

</script>

<style lang="scss" scoped>
  @media screen and (min-width: "1066px") {
    .resultados {
      table {
        tbody {
          tr {
            td {
              padding: 1rem .7rem;
              vertical-align: middle;
              text-align: center;
            }

            td:nth-child(1) {
              min-width: 9rem;
              padding: .9rem;
              text-align: left;
            }
          
            td:nth-child(2) {
              text-align: center;
            }            

            td:nth-child(3) {
              text-align: left;
            }

            td:nth-child(4) {
              text-align: left;
            }

            td:nth-child(5) {
              text-align: left;
              max-width: 50rem;
            }
          }

          .coluna-acoes-tabela {
            
            text-align-last: center;

            .icone-tabela {
              width: fit-content;
              display: inline-block;
              background-color: #fff;
              margin: 0 .05rem 0 .05rem;
            }
          }
        }
      }
    }
  }
  .modal-exclusao {
    visibility: hidden;
  }
  .texto-centralizado {
    text-align: center;
    margin-bottom: 0.5rem;
  }
</style>